<template>
    <div class="wrapper" style="height: 100vh;margin-left: -300px;">
        <div class="dis-table">
            <div class="table-cell">
                <!-- |************************************************** Main **************************************************| -->
                <main class="main-content">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <form class="login" @submit.prevent="submitForm"
                                      @keydown="form.errors.clear($event.target.name)">
                                    <div class="form-group">
                                        <label for="email">{{i18n("Login")}}</label>
                                        <input type="text" class="form-control" id="email"
                                               v-model="form.email"
                                               :class="form.errors.has('email') || form.errors.errorMessage ? 'is-invalid' : ''"
                                        >
                                        <div class="invalid-feedback" v-if="form.errors.has('email')">
                                            {{form.errors.get('email')}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="password">{{i18n('Password')}}</label>
                                        <div class="input-group">
                                            <input :type="isShowedPassword ? 'text' : 'password'"
                                                   class="form-control" id="password"
                                                   ref="password"
                                                   v-model="form.password"
                                                   :class="form.errors.has('password') || form.errors.errorMessage ? 'is-invalid' : ''"
                                                   aria-describedby="validationTooltipUsernamePrepend"
                                            >
                                            <div class="input-group-append" @click="showPassword">
                                                <span class="input-group-text" id="validationTooltipUsernamePrepend">
                                                    <i v-if="!isShowedPassword" class="mdi mdi-eye-off"></i>
                                                    <i v-else class="mdi mdi-eye"></i>
                                                </span>
                                            </div>
                                            <div class="invalid-feedback"
                                                 v-if="form.errors.has('password') || form.errors.errorMessage">
                                                {{form.errors.get('password')}} {{form.errors.errorMessage}}
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit"
                                            class="btn w-100 base_btn solid_blue waves-effect waves-light">
                                        <span class="loader-15" v-if="isLoading"></span>
                                        <span v-else>{{i18n("Enter")}}</span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
                <!-- |********** Main **********| -->
            </div>
        </div>
    </div>
</template>

<script>
    import FormService from '../../services/FormService';

    export default {
        data() {
            return {
                form: new FormService({
                    email: '',
                    password: ''
                }),
                isLoading: false,
                isShowedPassword: false,
            }
        },
        created() {
            this.$store.commit('toggleLeftMenu', false);
        },
        methods: {
            showPassword() {
                this.isShowedPassword = !this.isShowedPassword;
            },
            submitForm() {
                this.isLoading = true;
                this.form.submit('POST', this.route('api.login'))
                    .then(response => {
                        if (!response.errors) {
                            let authObj = JSON.stringify(response.data.auth);
                            localStorage.setItem('authToken', response.data.access_token);
                            localStorage.setItem('auth', authObj);
                            this.$store.commit('loadAuth', authObj);
                            this.$store.commit('loadPerms', response.data.auth.permissions);
                            this.$store.commit('toggleLeftMenu', true);
                            if (this.$route.params.nextUrl != null) {
                                this.$router.replace(this.$route.params.nextUrl)
                            } else {
                                this.$router.replace({name: "main"});
                            }
                        } else {
                            alert('error, open console');
                            console.log(response);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.form.errors.errorMessage = error.wrong_credentials;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
